import React from 'react';
import { useSelector } from 'react-redux';
import { supwizConfigSelector } from 'modules/app/selectors';
import { isServer } from 'utils';

export const useSupwizChat = () => {
  const { supwizCustomerId, supwizUrl }: State.SupwizConfig = useSelector(supwizConfigSelector);

  const removeElement = React.useCallback(() => {
    const element = document.querySelector('#pzlModuleLoader');
    if (element && element.parentNode) element.parentNode.removeChild(element);
  }, []);

  React.useEffect(() => {
    if (isServer || !supwizUrl || !supwizCustomerId) {
      console.log(
        `[SupwizChat] Not injecting script: isServer=${isServer}, supwizUrl=${supwizUrl}, supwizCustomerId=${supwizCustomerId}`
      );
      return;
    }

    const body = document.querySelector('body');
    if (!body) return;

    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', 'pzlModuleLoader');
    script.setAttribute('data-customer-id', supwizCustomerId);
    script.src = `${supwizUrl}/public/js/pzl_loader.js`;
    document.body.appendChild(script);

    // cleanup script on hook unmount
    return removeElement;
  }, [supwizUrl, supwizCustomerId, removeElement]);
};
